export type CallNetworkHealth = 'ok' | 'weak' | 'reconnecting';

/** A dropped media path reads as reconnecting; any warning or error from the stats reads as weak. */
export const networkHealthOf = (connectionState: RTCPeerConnectionState | undefined, severity: 'ok' | 'warn' | 'error'): CallNetworkHealth =>
    connectionState === 'disconnected' || connectionState === 'failed' ? 'reconnecting' : severity === 'ok' ? 'ok' : 'weak';
